<template>
    <div class="fibu-amount-input">
        <b-input-group :size="size">
            <template #prepend>
                <b-input-group-prepend>
                    <b-select
                        :size="size"
                        :options="options"
                        v-model="amountType"
                    />
                </b-input-group-prepend>
            </template>
            <b-input
                :id="id"
                :size="size"
                :value="localValue"
                type="number"
                :disabled="disabled || isBusy"
                @input="input"
                :min="min"
                :max="max"
            />
            <template #append>
                <b-input-group-text>€</b-input-group-text>
            </template>
        </b-input-group>
    </div>
</template>

<script>
export default {
    name: "FiBuAmountInput",
    props: ["id", "size", "value", "isBusy", "disabled", "min", "max"],
    data() {
        return {
            localValue: this.value,
            amountType: this.max === 0 ? "outcome" : "income",
            options: [
                {
                    value: "income",
                    text: this.max === 0 ? "Einzahlung" : "Einnahme",
                    // disabled: this.max === 0
                },
                {
                    value: "outcome",
                    text: this.max === 0 ? "Forderung" : "Ausgabe",
                    disabled: this.min === 0
                }
            ]
        };
    },
    watch: {
        value: {
            handler(val) {
                this.localValue = val;
            }
        },
        localValue: {
            handler(val) {
                if (val < 0 && this.amountType == "income") {
                    this.amountType = "outcome";
                } else if (val > 0 && this.amountType == "outcome") {
                    this.amountType = "income";
                }
            }
        },
        amountType: {
            handler(val) {
                if (val == "income") {
                    this.localValue = Math.abs(this.localValue);
                } else {
                    this.localValue = Math.abs(this.localValue) * -1;
                }
            }
        }
    },
    methods: {
        input(value) {
            if (this.min === 0 && value < 0) {
                value = Math.abs(value);
            }

            // if (this.max === 0 && value > 0) {
            //     value = value * -1;
            // }

            this.$emit("input", value);
        }
    }
};
</script>
